<template>
  <v-app id="inspire">
    <v-main>
      <div class="nav-sidebar">
        <Navigation :authenticatedUser="userStore.auth">
          <template v-if="side_nav_items.length > 1" v-slot:items>
            <SiderBarItems
              :items="side_nav_items"
              :roles="userStore.getRoles"
              :permissions="userStore.getPermissions"
              usertype="student"
              environment="main"
            />
          </template>
        </Navigation>
      </div>
      <div class="main-content">
        <Overview v-if="$route.name === 'Student'" :authenticatedUser="userStore.auth"></Overview>
        <router-view :key="$route.fullPath" />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Navigation from "../../Navigation_modules/CustomNavigationDrawer";
import SiderBarItems from "../../Navigation_modules/SideBarItems";
import Overview from "./Overview.vue";
import StudentAPI from "../../../apis/Student";

export default {
  name: "StudentDashboard",
  components: { Navigation, Overview, SiderBarItems },

  data() {
    return {
      is_fresher: true,
      transfer_request_object: {
        text: 'Transfer Request',
        icon: 'transfer-requests',
        route: 'transfer-requests',
        permissions: []
      },
      clearance_object: {
        text: "Clearance",
        icon: "course-reg",
        route: "clearance",
        permissions: []
      },
      convocation_object: {
         text: "Convocation Fees",
         icon: "payment-method",
         route: "convocation-fees",
         permissions: []
      },
      transcript_object: {
         text: "Academic Transcript",
         icon: "degree",
         route: "transcript",
         permissions: []
      },
      lecturer_assessment: {
         text: "Question Response",
         icon: "degree",
         route: "questionnaire-response",
         permissions: []
      },

      on_demand_clearance_object: {
         text: "On-Demand Clearance",
         icon: "ticket-outline",
         route: "on-demand-clearance",
         permissions: []
      },

      side_nav_items: [],
      student_info: {},
    };
  },

  created() {
    StudentAPI.getStudentByID(this.userStore.auth.id)
      .then(response => {
        this.student_info = response.data.student;
        this.is_fresher = response.data.student.is_fresher;
        let graduated = this.student_info.session_graduated;
        this.setSidenavMenu(this.userStore.getSubdomain);
        if (this.is_fresher === false) {
          this.side_nav_items.splice(5, 0, this.transfer_request_object);
        }
        if (graduated) {
          this.side_nav_items.splice(11, 0, this.clearance_object);
          this.side_nav_items.splice(12, 0, this.convocation_object);
          this.side_nav_items.splice(13, 0, this.transcript_object);
        }

        if(this.student_info.institution.accronym == "FUO") {
          this.side_nav_items.splice(11, 0, this.on_demand_clearance_object);
        }
      });
  },

  methods: {
    setSidenavMenu(subdomain) {
      this.side_nav_items = [
        { text: "Home", icon: "dashboard", route: "", permissions: [] },
       // { text: "Courses", icon: "courses", route: "courses", permissions: [] },
        { text: "Lectures", icon: "lecturer", route: "lectures", permissions: [] },
        { text: "Announcements", icon: "annoucement", route: "announcements", permissions: [] },
        { text: "Course Management", icon: "course-management", route: "course", permissions: [] },
        { text: "SIWES", icon: "course-management", route: "siwes", permissions: [] },
        { text: "Results", icon: "results", route: "my-results", permissions: [] },
        { text: "Rate Lecturer", icon: "assessment", route: "rate-lecturer", permissions: [] },
        { text: "Fees & Receipts", icon: "fees", route: "fees", permissions: [] },
        { text: "Invoices", icon: "invoices", route: "invoices", permissions: [] },
       // { text: "Supplementary Fees", icon: "payment-method", route: "supplementary-fee", permissions: [] },
        { text: 'Transactions Validation', icon: 'transactions', route: 'transaction-validation', permissions: [] },
        { text: "Hostel Accomodations", icon: "acccomodation", route: "hostel-booking", permissions: [] },
        { text: "Elections" , icon: "elections", route: "elections", permissions: [] },
        { text: "Tickets" , icon: "ticket-outline", route: "tickets", permissions: [] },
        

      ];
    },
  },
};
</script>
